<div class="pme-alert display-utils-row display-utils-start display-utils-gap-8" [ngClass]="{
    'pme-alert-error' : type == 'error',
    'pme-alert-success' : type == 'success',
    'pme-alert-warn' : type == 'warn',
    'pme-alert-info' : type == 'info',
    'pme-alert-default  ' : type == 'default'
  }">
  <div *ngIf="this.type!=='default'">
    <mat-icon class="pme-alert-icon" *ngIf="type !== 'default'"
      [fontSet]="type === 'success' ? 'material-icons' : 'material-icons-outlined'">
      {{ type === 'success' ? 'check_circle' : 'report' }}
    </mat-icon>
  </div>
  <div>
    <div class="pme-alert-title" *ngIf="title" [innerHTML]="title"></div>
    <ng-content></ng-content>
  </div>
</div>